import axios from 'axios';
const requestURL = '/faq/all';

const initFaqLoad = () => {
  const $loadBtn = document.querySelector('[data-faq-load]');

  if (!$loadBtn) {
    return;
  }

  const loadTargelSelector = $loadBtn.dataset.faqLoad;
  const $loadTargetEl = document.querySelector(loadTargelSelector);
  const $loader = $loadTargetEl.nextElementSibling;


  $loadBtn.addEventListener('click', function (e) {
    e.preventDefault();
    showLoader($loader);

    // Запрос
    axios.get(requestURL).then((response) => {
      hideLoader();
      $loadTargetEl.innerHTML += response.data;
    }).catch((error) => {
      console.error(error);
      hideLoader();
    });
  });


  function showLoader() {
    $loadBtn.disabled = true;
    if ($loader.classList.contains('scroll-loader')) {
      $loader.classList.remove('hidden');
    }
  }

  function hideLoader() {
    $loadBtn.disabled = false;
    if ($loader.classList.contains('scroll-loader')) {
      $loader.classList.add('hidden');
    }
  }
};

export {initFaqLoad};

